import React from 'react';

import { SvgIcon, SvgIconProps } from '_lib/components/SvgIcon/SvgIcon';

export const AiCallIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox='0 0 24 24'>
      {/* Phone handset */}
      <path d='M6.62 10.79a15.053 15.053 0 0 0 6.59 6.59l2.2-2.2a.996.996 0 0 1 1.01-.24c1.12.37 2.33.57 3.58.57 .55 0 1 .45 1 1V20c0 .55-.45 1-1 1C10.07 21 3 13.93 3 5c0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.46.57 3.58.11.34.03.74-.25 1.01l-2.2 2.2Z' />

      {/* AI sparkles: AutoAwesome source scaled to .55 size and positioned in upper-right */}
      <path
        transform='translate(10, 0.5) scale(0.55)'
        d='m19 9 1.25-2.75L23 5l-2.75-1.25L19 1l-1.25 2.75L15 5l2.75 1.25zm-7.5.5L9 4 6.5 9.5 1 12l5.5 2.5L9 20l2.5-5.5L17 12zM19 15l-1.25 2.75L15 19l2.75 1.25L19 23l1.25-2.75L23 19l-2.75-1.25z'
      />
    </SvgIcon>
  );
};
